export function RemoveProperty(object: any, props: Set<string>): void {
  if (object === undefined || object === null) {
    return;
  }

  Object.keys(object).forEach((key) => {
    if (props.has(key)) {
      delete object[key];
    }

    if (object[key] instanceof Array) {
      object[key].forEach((data) => RemoveProperty(data, props));
    }

    if (typeof object[key] === 'object' && object[key] !== null) {
      RemoveProperty(object[key], props);
    }
  });
}
